// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1TH5O","left":"StickyBox_left__34qvu","right":"StickyBox_right__3RDRY"};